import { render, staticRenderFns } from "./FaceBook.vue?vue&type=template&id=91afc204&scoped=true"
import script from "./FaceBook.vue?vue&type=script&lang=js"
export * from "./FaceBook.vue?vue&type=script&lang=js"
import style0 from "./FaceBook.vue?vue&type=style&index=0&id=91afc204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91afc204",
  null
  
)

export default component.exports